import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { publicCardUrl } from '../utils/cards';
import { downloadVCF } from '../utils/vcf';

const btn = 'h-10 px-3.5 rounded-lg border border-line-strong bg-white text-sm font-semibold text-ink hover:bg-surface disabled:opacity-50';

/** QR code, share link and downloads for one card. */
export default function ShareTools({ card, theme }) {
  const [qr, setQr] = useState('');
  const [copied, setCopied] = useState(false);
  const url = publicCardUrl(card.slug);

  useEffect(() => {
    QRCode.toDataURL(url, { width: 600, margin: 1, color: { dark: '#0B1530', light: '#FFFFFF' } })
      .then(setQr)
      .catch((err) => console.error('QR code generation failed:', err));
  }, [url]);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt('Copy your card link:', url);
    }
  };

  const downloadQr = () => {
    const a = document.createElement('a');
    a.href = qr;
    a.download = `${card.slug}-qr.png`;
    a.click();
  };

  return (
    <section className="bg-white rounded-2xl border border-line p-6 flex flex-col gap-5 min-w-0">
      <h2 className="text-[22px] font-bold">Share your card</h2>
      <div className="flex flex-wrap gap-5 items-center">
        <div className="w-40 h-40 p-3 border border-line rounded-2xl bg-white shrink-0">
          {qr ? <img src={qr} alt="QR code for your card" className="w-full h-full" /> : <div className="w-full h-full bg-surface rounded" />}
        </div>
        <div className="flex-1 min-w-[200px] flex flex-col gap-2.5">
          <label htmlFor={`link-${card.id}`} className="text-xs font-semibold tracking-wider uppercase text-ink-muted">Your card link</label>
          <div className="flex gap-2">
            <input id={`link-${card.id}`} readOnly value={url.replace(/^https?:\/\//, '')} onFocus={(e) => e.target.select()}
              className="flex-1 min-w-0 h-[42px] px-3 border border-line-strong rounded-lg font-mono text-sm text-ink bg-surface" />
            <button onClick={copy} className="h-[42px] px-3.5 rounded-lg bg-navy text-white text-sm font-semibold hover:bg-ink/90">
              {copied ? 'Copied' : 'Copy'}
            </button>
          </div>
          <div className="flex flex-wrap gap-2 mt-1">
            <button onClick={downloadQr} disabled={!qr} className={btn}>Download QR</button>
            <button onClick={() => downloadVCF(card, theme)} className={btn}>Contact file</button>
            <a href={url} target="_blank" rel="noopener noreferrer" className={`${btn} inline-flex items-center`}>Open card</a>
          </div>
          {card.status !== 'active' && (
            <p className="text-sm px-3 py-2 rounded-lg bg-coral-soft text-coral-ink">
              This card is {card.status}, so visitors can't open it yet.
            </p>
          )}
        </div>
      </div>
      <p className="text-sm text-ink-muted border-t border-line pt-4">Add to Apple Wallet is coming soon.</p>
    </section>
  );
}
